<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex md12 v-if="this.funcionario.item != null">
            <strong>Nro de item:</strong> {{ this.funcionario.item }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.padres_unidad != null">
            <strong>Dependencia:</strong> {{ this.funcionario.padres_unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.unidad != null">
            <strong>Nombre unidad:</strong> {{ this.funcionario.unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.cargo != null">
            <strong>Cargo:</strong> {{ this.funcionario.cargo }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.puesto != null">
            <strong>Puesto:</strong> {{ this.funcionario.puesto }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.sueldo != null">
            <strong>Sueldo:</strong> {{ this.funcionario.sueldo }}
          </v-flex>
        </v-layout>

        <v-layout wrap row>
          <v-flex md4>
            <v-text-field
              type="date"
              label="Fecha desde"
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              @change="alertarAprobacion()"
              @input="esFeriadoOFinDeSemana(form.fecha_desde, 1)"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap> </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios</small
      >
      <v-spacer></v-spacer>
      <v-btn @click.native="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :loading="loading"
        :disabled="!valid"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: [
    "id_tipo_justificacion",
    "funcionario",
    "unidades",
    "cargos",
    "puestos",
    "data",
  ],
  data() {
    return {
      valid: false,
      loading: false,
      form: this.data,
      treeOrganizacion: [],
      obtenerOrganigrama: [],
      tree: [],
      fecha_futuro: false,
      bandera_fecha: false,
    };
  },
  mounted() {
    this.fijarDatosFuncionario();
  },
  methods: {
    alertarAprobacion() {
      // Estado programado
      if (this.form.id_estado == 64) {
        if (
          this.$moment() >= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono la fecha actual o una fecha pasada, por lo tanto la movilidad se aprobara si la guarda"
          );
        }
      }
      // Estado suspendido
      if (this.form.id_estado == 18) {
        if (
          this.$moment() <= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono una fecha a futuro, por lo cual no puede guardar la movilidad, ya que fue aprobada"
          );
          this.fecha_futuro = true;
        } else {
          this.fecha_futuro = false;
        }
      }
    },
    async esFeriadoOFinDeSemana(fecha, valor){},
    async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ",fecha);
          this.bandera_fecha = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `,
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(`La fecha ${this.$moment(fecha).format('DD/MM/YYYY')} cae en fin de semana o feriado`);
              this.bandera_fecha = true;
              return true;
            }

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      let validacion_fecha=await this.esFeriadoOFinDeSemanaVerificar(this.form.fecha_desde,1)
          if (validacion_fecha ) {
            return;
          }
      if (this.form.editar) {
        try {
          if (this.$refs.form.validate()) {
            this.loading = true;
            let id_puesto = this.form.id_puesto;
            let id_cargo = this.form.id_cargo;
            let id_tipo_justificacion = this.id_tipo_justificacion;

            let user = this.$storage.get("user");
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.form.nro_item}, ${id_tipo_justificacion},'${this.form.fecha_desde}',${this.form.id_estado})"){
                    respuesta
                  }
                }
              `,
            });
            res =
              res.runQuery.respuesta[0].fn_modifica_movilidad_interinato_estado;
            let resps = res.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success("Modificación exitosa");
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          if (this.$refs.form.validate()) {
            let id_puesto = this.funcionario.id_puesto;
            let id_cargo = this.funcionario.id_cargo;
            let id_tipo_justificacion = this.id_tipo_justificacion;

            let user = this.$storage.get("user");
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_temporal(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.funcionario.nro_item}, ${id_tipo_justificacion},'${this.form.fecha_hasta}')"){
                    respuesta
                  }
                }
              `,
            });

            res = res.runQuery.respuesta[0].fn_alta_movilidad_temporal;

            let resps = res.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success(resps);
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearMovilidad");
    },

    fijarDatosFuncionario() {
      if (this.id_tipo_justificacion === 2) {
        this.form.id_unidad = this.form.id_unidad;
        this.form.padres_unidad = this.form.padres_unidad;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/Suspencion.vue